import Header from "./components/Header/Header";
import Hero from "./components/Hero";
import Brand from "./components/Brand";
import Service from "./components/Service";
import Banner from "./components/Banner";
import Testimonial from "./components/Testimonial";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { useEffect, useRef, useState } from "react";

function App() {
  const [targetId, setTargetId] = useState("home");
  const homeRef = useRef();
  const serviceRef = useRef();
  const testimonialRef = useRef();
  const aboutRef = useRef();
  const contactRef = useRef();

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px 0px 0px 0px",
      threshold: 0.8,
    };
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];

      // eslint-disable-next-line no-unused-expressions
      entry.isIntersecting ? setTargetId(entry.target.id) : "";
    }, options);

    observer.observe(homeRef.current);
    observer.observe(serviceRef.current);
    observer.observe(testimonialRef.current);
    observer.observe(aboutRef.current);
    observer.observe(contactRef.current);

    return () => {};
  }, []);

  return (
    <>
      <Header target={targetId} />
      <Hero ref={homeRef} />
      <Brand />
      <Service ref={serviceRef} />
      <Banner />
      <Testimonial ref={testimonialRef} />
      <About ref={aboutRef} />
      <Contact ref={contactRef} />
      <Footer />
    </>
  );
}

export default App;
